import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  ListEnvelopeAccessesParams,
  ListEnvelopeAccessesResponse,
} from './list-envelope-accesses.types'

export const envelopeAccessesQueryKey = (
  envelopeId: string,
  params: ListEnvelopeAccessesParams,
) => ['envelope-accesses', envelopeId, params] as const

const listEnvelopeAccesses = async (
  envelopeId: string,
  params: ListEnvelopeAccessesParams,
): Promise<ListEnvelopeAccessesResponse> => {
  const response = await apiClient.get<ListEnvelopeAccessesResponse>(
    `/v1/ecm/envelopes/${envelopeId}/accesses`,
    { params: { PageNumber: params.pageNumber, PageSize: params.pageSize } },
  )
  return response.data
}

export const useListEnvelopeAccesses = (
  envelopeId: string,
  params: ListEnvelopeAccessesParams,
) => {
  return useQuery({
    queryKey: envelopeAccessesQueryKey(envelopeId, params),
    queryFn: () => listEnvelopeAccesses(envelopeId, params),
    placeholderData: keepPreviousData,
  })
}
